import digitalcat from '../../../../assets/landing/digitalcat.png';
import dk from '../../../../assets/landing/dk.png';
import shibha from '../../../../assets/landing/shibha.png';


export const categorizedImagesData = [
    {
        id:1,
        url:digitalcat,
        type:"🎨 Art"
    },
    {
        id:2,
        url:dk,
        type:"🏏 Sport"
    },
    {
        id:3,
        url:shibha,
        type:"🐼 cartoon"
    }

]